export default __webpack_public_path__ + "static/media/ParallaxCache.31d6cfe0.bin";